module.exports = __webpack_public_path__ + "9deeac19d66356f23d9a08f4ac122c19.svg";